<template>
    <v-dialog-old ref="userDialog" id="userDialog" :onCloseEsc="() => {closeDialog(false)}">
        <a href="#close" style="text-align: center" @click.stop.prevent="closeDialog(false)"></a>
        <div class="dialog-container">
            <ValidationObserver ref="userEditForm">
                <fieldset>
                    <legend>Пользователь</legend>
                    <label>Логин</label>
                    <vee-input
                        @input="checkLogin"
                        :rules="{required: true, loginNotAvailable: !freeLogin}"
                        v-model="user.login"
                        input-class="large"
                        autocomplete="off"
                    />
                    <label v-if="user.id">
                        <input type="checkbox" v-model="user.changePassword">
                        <span>Сменить пароль</span>
                    </label>
                    <div v-if="user.changePassword || !user.id">
                        <label v-if="user.changePassword">Новый пароль</label>
                        <label v-else>Пароль</label>

                        <div style="position: relative">
                            <vee-input
                                rules="required|min:6"
                                name="Пароль"
                                :type="passwordVisible ? 'text' : 'password'"
                                v-model="password"
                                input-class="large"
                                autocomplete="new-password"
                            />
                            <img v-if="passwordVisible" @click="hidePassword" tooltip="Скрыть пароль" width="24" height="24" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAEhklEQVR4Xu2ajZFMQRCA+yJABIgAESACRIAIEAEiQARcBIgAESACRIAIqE9tX8319kxPz3u37mZvqrZu7Xtvuvub/pt5DmTPx8Ge2y/nAM49oE3gioh8nxlSKwQeiMhrEXkoIm9mhVADoMar3dNC8ADg9t+cFZ8SQq8HTOsJPTnAOsNUnhD1ATYXTOcJEQAMnhpCD4CpIfQCmBZCBsCUELIApoMwAmAEwnURuSkiNFl85y+fcrDnKD8fReTTSbfgowAiCO9E5I6I3BWRWyJycYEhgGC+QxH5tWAe99ElAFoQ1tZT5wMEG7P3awlYCuB/QEAmofJs4xWLWKwBoAfCbxHBlb9s/uLKfNdBiJAbGIQM3/lcDqxbDGIUAArbeKx1jK9E5PHgMgGBPMLcLRjAfLKBmxKVBYDhTzcK3TarGCXGpYcqeAYg7jcsfCkizzPJMgMABd4WGR0P2DUEbAdkCwJhwY6VkAtHL4AXFTcehYABhIXGPS7M6lHqolE7sLHPMR9h0RwRAFz+Q6GoN1kWAitkmyCdFxB4VVTvue9aZNzGC+615msBYHUw3mtiSGwYQbPDQOGricTY0h3jbgTGUQLJRTroCwD7yHmO34FQVp2j22oAyLycCFvjKWdcI7740N7qYOW8uKtVh5aN0akT+YjF0UHLzG98aJYumMlZICBs6ecBqCmMEIxX9/xjhFxquFoWQuQFLMxPI19t4RqGeiGyBdYCqClKcuJaOSyAKJ9kIUTzRfJr1eIYhFJI9ugrUsBz8QyEpQCQT6WhgtlxBEGFkPA+t250rhEKZayRuNxEY57tgfA1qDxWX3JTbcdZk/dPXwVgk4rq3EpGvUlwxBNGk2BG1jEAPFgjhRtR9uywMUYLSnnqHTV5Pxp9gs5ty6CXo7iXskhDFIaA3lBTCmNZlXLY+Ioyd2Z1Ig8gXLWLZF7vfsq4Tdxb92bKIAZSS/V1udeS0gxlX6dnk28kt9W9hmVQV6nVUDAJzQbD5gF+B1J2ZCCwIaMf0UEXqP9uNXDYtJWko1YYg7x9uG47VWBpcK0jjKD0QPCStXZ4tMbeuQMVhblTrbAqizsBoWx59Rquzm6LhFR2XfxOho02NNmcgB68ti/LHd0p8ol3b4Nlu9ctmVGzoQ/YrFtO5O3uRhJilIg9Oa2dZVdV6gWAcrgf1SA6p1NDere2GU+IwojrlFFCs6cpS/83OdwPb/C2nZ5yqdMZM0FPx2hlsurkp+7wy3hAKYwajCAvN3ggiF/yxVol0sog1kmAXatePjwKoIxXPCITFsCgfNK/q8J4FokU97WQWp7A/VzvOv/zVmYpgFEQtVjOHq9FHWOYM9YCoIJ6jq4jpXYKYW0AZf+gL0b5a4+oTg2EkwJgDdRXXTQreAmjTKBlPiAvkAf0VZqdq6djjAAfXd8VgG6FOm9cDcJZBQCnVSCcZQCrQDjrABZDmAHAIgizABiGMBOAIQizAUhDmBFAC8LWcd2sADwI7ruDmQGUEGovTtInQp2d6qm6jb1H9bxgdg8IV+IcQIho8hv23gP+Ak1HM1BAtIt+AAAAAElFTkSuQmCC" style="position: absolute; top: 6px; right: 6px;cursor: pointer">
                            <img v-else @click="showPassword" tooltip="Показать пароль" width="24" height="24" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAESUlEQVR4Xu2ZjbENQRCFz4uADBABIkAEiAARIAJEgAgQASJABJ4IEAEioD61/Wpe35np2Z+7Vu101dZVdne6+8w53b3zTrRzO9l5/uoAdAbsHIEugZ0ToBfBLoEugZ0j0CWwcwL0LtAl0CWwDgI3JN2UdHm4Lkq65lyfSvop6dtwfZT06djhHUsCJHpb0p0h8Tl5AMQ7Se8HYOasdfDu0gDck3R/gaRLSQLGa0lvlkJhCQCg88MhcXZ+DUMmAPFykM1kn3MBeCLpkSRAqNl3SewegfOL2a+9R43ArFbweylYl5qB/8mMmAoAwb0aClopxi/DLqFfEp9iMIo6gqyuVhZg/QcZUEOfYwFgp0mcoHL2ayhYLyRR1Zc0uga7TZ0pGWADBMxosjEAkDTJ1+gOFdmtYxrar4FA8oAAGKG1AvB8QD9a8Eoj3a1o2iwAW2BNi5aRxdcokGG9x9FzEQDs9ofM0JJbF8374cY/F60HELcaKMxztZpgfsP1agCQDMnnKE/7sWHHnIE2u1izzw0gEfT1YJ2nkuhAZjYkwSxvSAJQszWpBAA6hvY+eYoc99AXbYwR1wwnvrWlwVDAWLPF0DBaLxldiM0xY2Tm/6hTvHfBvVisCzkASJBi5w2K48Ba2m/3QCSnlt23JSMWsDE/Cv5hJhuUk8gBsD7oUvJQjHtpexkLgH8+YkIEaM0/AMEEvke8nQMhdVJKvtTatgyAJV1qmWcgGAAUPCjqrdbXYUOqtagFtlZuYog6io+X2lSaT0ogUGhPDQBfVFIEQStnWyyCuTipZ7nh7BwAvFiSAAjmQPDIPpNEe6pZCwui3Wd93wZLTC0lfyABC7oGAn0+LYK+rUWVGx/QFOaUhhiSh43RLO87iq/u+KHl5na+WAQjEPxUlRtJozqQ+gBAA4LEGaJqvd/ejfxy/21h4ArboDmpDRR33Td9Ogz9i48hG4KIHfaQfG2AOyfRaBSGrn6qMg2i+Zxk/haXqMlPvJ/rVrarjMa5GkSHAJhRo7DFV9MsC9r8n2qaSREQIh2PxYBY0H567IZ0rBblPsTCmhJNWxYk+sx9aHAfILxzRlGksqRBbX8Qk/NtPvlgA5yqtQJg+qJIRed05jD8FI2CG+5Hn9B+Gc4fkWbtw+zsnTEAWBuDDbUTmTQgk0lTMBlA0C7tLDpnsFcpwux6s/zGAmCOCAwgWg4leAfmUDRbD0fROUWt9XjNasFooKcCYEAQIJW3VRYEaBdB205Bc8AEWLtaFALd8d8yP2TXmwvAVCBakqs9MztxW3wpAGw9O8PPfYfPTZr3OZdgt5tOfFscLg2A+YTSgME1FwySJmGu5uLWkjzPHAsA758qbn/y4t+m+fQ5qwl0DvsT2rEmysltsBXY/+a5tRiwWUA6AJvdmpUC6wxYCejNuukM2OzWrBRYZ8BKQG/WTWfAZrdmpcA6A1YCerNuOgM2uzUrBfYH/6zsQTLY9P4AAAAASUVORK5CYII=" style="position: absolute; top: 6px; right: 6px;cursor: pointer">

                            <img @click="genPassword" tooltip="Придумать случайный пароль" width="20" height="20" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEFklEQVRoQ82ZgZENQRCG+yJABIgAESACROBEgAgQASJwIkAEiAARIAMioL6tadU72zPTMzvvPVN1pdzuzvT/d/ffPX1ncrh1TUTuich5OuJCRD6IyI+ZR57N3ExErNE3C3t/FZFpYGYAuJyYvi8i/PSs9yLCD5751fOhvjsKYI/RJTuHwPQCIKaVaUAcYuEJC6Z6RgTAMYwuGdkEUwJAAj5MbJOYI+tbYtJ+e0dEbo9sltQLz7wVEYRgWRbADKN130dJaTxbOeeTiFwaBMJnSPECxgKAHTQb5veuKxVVIXe+i8jeHMITF14IETIAebKDJVz8XEQIIy1c7Hsj/b5UI1rE/RaRV8m7y74WwMf0EE3WBRAMudra+cDPfyY7KIC6iJRzC+BPegIyjMZFuggvPIIiHXNBJoyTMyytP9i3iIsHQA1Ewvj4tYlnPgIIntmThDUSCBOY5mwNPwx/nM5e5U4NgAVCxr/INtQ8mRVehInGt7YVEPbMNIQb4BEA9iOYIbTUpTyjMuOVUX3/nAyHJBuyMN7srXoB6AEAgC2b8LBFbEZlGCJ437bXS2KKCDkXWqMAdHMv4YlRzZM8vAgTjW8Nk01ihixPL+0FUEt4nsGmvdBYGSwm5ikA1BI+t6eZmKcEUEt44jqUmMcGoF0nzHoJrGGqhbLHvua7e3OAooPhmpBep/lfA0DDc8kjad8Y6loAIAG9R5rZi3oQrvJ7PeABwHbkVSW0BgDjMfrfBSXVF3IltPYCwNDrzkmwqZW5BuBpMthuQQ15GbK+0czle+hhxDxuprdnPXCujlRpZbEGwLv44BFa+9CKegClsZcQihAsA4IExgt2rkPBUkUqAaAqe/dtC74JIgqAnidvrPj/u3QCxpO8/AuD9Di6SgB4Fw/Y1X3djAIgyW45dES0vRZCNvzwBoTk103I03YE76xqjQeAcCGRYAMmNdYJk3wwCzB9XnJ3S0YJRfVcftHPVQ6QDAQ27uUXyubd7AqHkUii5wWrNqMAanHukbbyuueBfFJhVQGDmfngCVxpu8vZAHLhYH/C60vLA6OhMhuAJxwbhfI84E3VIqEyG0Ae/xv2ObA0VkFxrK6fAgD2ISbkHskL+5tpXklGqbR4AhDd2py5oqVCzWJVe8ECIFlBqbKI8aAPX7ALBx0KwCL3ueJgw+xx4mwAqzGjB0CJpIjtGfC2Wone0NHBrm1TVknsbagjEqZjo2uGB5gKEt6bPwTWPGAN7h1aebUm0jflJHnDr9U7UQD6EVoMEz1jxBEPUANUQque7wWgm+WKFVG6iAe0kbSz14MA0E0jihXxgPcHjFDOjXog37ymWK1LPSG5UpaQ5emlWQDYrqRYJQBFZTkVAD03V6wcQFNZTg0gVyxtRUjMkLL0APgLeu8UlhyrnCwAAAAASUVORK5CYII=" style="position: absolute; top: 6px; right: 40px;cursor: pointer">
                        </div>
                    </div>
                    <label>Фамилия Имя Отчество</label>
                    <vee-input
                        rules="required"
                        v-model="user.fio"
                        input-class="large"
                    />
                    <label>Email</label>
                    <vee-input
                        rules="email"
                        type="email"
                        name="Email"
                        v-model="user.email"
                        input-class="large"
                    />
                    <label>Телефон</label>
                    <ValidationProvider
                        v-slot="{ errors }"
                        rules="phone"
                    ><input
                        v-mask="'+7 (###) ###-##-##'"
                        v-model="user.phone"
                        class="large"
                        :class="{'hasError' : errors[0]}"
                        v-tooltip="{content: errors[0], template: $errTemplate}"
                    ></ValidationProvider>
                    <table style="width: 100%">
                        <tr>
                            <td style="width: 70%">
                                <label>Телефон рабочий</label>
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    rules="phone"
                                ><input
                                    v-mask="'+7 (###) ###-##-##'"
                                    v-model="user.work_phone"
                                    class="large"
                                    :class="{'hasError' : errors[0]}"
                                    style="width: 98%"
                                    v-tooltip="{
                                        content: errors[0],
                                        template: $errTemplate,
                                    }"
                                ></ValidationProvider>
                            </td>
                            <td style="text-align: right">
                                <label>Доб.</label>
                                <ValidationProvider v-slot="{ errors }" rules="numeric|max:5">
                                    <input v-mask="'#####'"
                                           v-model="user.work_phone_ext"
                                           class="large"
                                           :class="{'hasError' : errors[0]}"
                                           name="«Добавочный номер»"
                                           v-tooltip="{
                                               content: errors[0],
                                               template: $errTemplate,
                                           }">
                                </ValidationProvider>
                            </td>
                        </tr>
                    </table>

                    <label>Должность</label>
                    <input type="text" v-model="user.position" class=" large"/>

                    <label>Комментарий</label>
                    <textarea v-model="user.comment" rows="3"></textarea>
                </fieldset>
                <fieldset class="rightsAndRoles">
                    <legend>Роли пользователя</legend>
                    <user-roles v-model="user.roles" :available-roles="roles"></user-roles>
                </fieldset>
                <vee-fieldset
                    name="rightsAndRoles"
                    :rules="{requiredPermissions: (user.permissions.length === 0 && user.roles.length === 0) }"
                    fieldsetClass="rightsAndRoles"
                >
                    <legend>Права пользователя</legend>

                    <div>
                        <button class="small" @click.prevent="collapseAll">Свернуть все</button>
                        <button class="small" @click.prevent="expandAll">Развернуть все</button>
                    </div>

                    <div id="rights">
                        <template v-for="permission in permissions">
                            <permission-with-roles
                                :permission="permission"
                                :roles="user.roles"
                                v-model="user.permissions"
                                ref="permission"
                                :is-root="true"
                                :key="permission.text"
                            />
                        </template>
                    </div>
                </vee-fieldset>
                <fieldset>
                    <legend>Настройки почты</legend>

                    <label>Email (полностью с доменом)</label>
                    <input type="text" v-model="user.params.report.emailLogin">

                    <label>Пароль</label>
                    <input type="text" v-model="user.params.report.emailPassword">

                    <button class="small" @click="checkEmail">Проверить отправку</button>

                    <label>Подпись</label>
                    <textarea v-model="user.params.report.emailSignature" rows="3"></textarea>
                </fieldset>
            </ValidationObserver>
        </div>
        <template v-slot:footer>
            <button v-if="user.id" :disabled="!needSave" :class="[{green: needSave}]" @click="saveUser" type="submit">Сохранить</button>
            <button v-else class="green" @click="saveNewUser" type="submit">Создать</button>
            <button class="red" @click="deleteUser" v-if="user.id && !user.self">Удалить</button>
        </template>
    </v-dialog-old>
</template>

<script>

import PermissionWithRoles from "./PermissionWithRoles";
import UserRoles from "./UserRoles";
import Base from "@mixins/UserEdit.vue";
import {mapState} from "vuex";

export default {
    components: {
        'permission-with-roles': PermissionWithRoles,
        'user-roles': UserRoles,
    },
    mixins: [Base],
    computed: {
        ...mapState({
            currentUser: state => state.currentUser,
        }),
        needSave: function () {
            return (this.Mhashcode !== null && (this.Mhashcode !== JSON.stringify(this.user).hashCode())) || this.currentUser.role === 'admin';
        },
    },
}
</script>
